import { Text } from '@medly-components/core';
import { FC, type MouseEvent } from 'react';

import { ArrowBackIcon } from '@medly-components/icons';
import { useNavigate } from 'react-router-dom';
import { BackButtonStyled } from './BackButton.styled';
import type { BackButtonProps } from './types';

export const BackButton: FC<BackButtonProps> = ({ to = -1, onClick, ...restProps }) => {
    const navigate = useNavigate();

    const handleOnClick = (event: MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);
        // @ts-expect-error
        navigate(to);
    };

    return (
        <BackButtonStyled onClick={handleOnClick} {...restProps}>
            <ArrowBackIcon size="S" />
            <Text textVariant="body1" textWeight="Medium">
                Back
            </Text>
        </BackButtonStyled>
    );
};
